import SimpleSlotView from './SimpleSlotView';

class SpacerSlotView extends SimpleSlotView {
  render(): this {
    super.render();
    this.$('.assembly-slot-options .set').remove();
    this.$('.assembly-slot').addClass('assembly-slot-spacer');
    return this;
  }
}

export default SpacerSlotView;
